module.exports = __webpack_public_path__ + "static/media/header-sample.464ca6c0.png";